import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"palace-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M3 21V10H7V9C7 6.23858 9.23858 4 12 4C14.7614 4 17 6.23858 17 9V10H21V21H3Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z"}},{"tag":"g","attrs":{"id":"stroke2"},"children":[{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M11.998 6.99805H12.002V7.00195H11.998V6.99805Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"stroke":"props.strokeColor2","d":"M9 21V18.3541C9 16.2985 10.1614 14.4193 12 13.5C13.8386 14.4193 15 16.2985 15 18.3541V21H9Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 10V9C7 6.23858 9.23858 4 12 4M7 10H17M7 10H3M17 10V9C17 6.23858 14.7614 4 12 4M17 10H21M3 10V21H21V10M3 10V4M21 10V4M12 4L12.002 3","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Palace2 = Vue.extend<IconProps>({
  name: 'Palace2Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'palace-2',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Palace2;
